<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="$t('warehouse.Dispensewarehouse')"
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col class="mt-1" lg="12">
            <b-form-group :label="$t('common.date')" label-for="Date">
              <datepicker
                v-model="date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD H:i"
              ></datepicker>
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group :label="$t('common.quantity')">
              <b-form-input
                v-model="EditForm.quantity"
                :placeholder="$t('common.quantity')"
              />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group :label="$t('common.price')">
              <b-form-input
                v-model="EditForm.price"
                :placeholder="$t('common.price')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card :title="$t('warehouse.balance')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("warehouse.item") }}</h2>
            <br />
          </b-col>
          <b-col md="4" cols="12">
            <CategoryFilterModal
              @category="assignCategoryFilter"
              :isPharmacy="$route.name.includes('pharmacy') ? true : false"
            />
          </b-col>
          <b-col md="4" cols="12">
            <AutoComplete
              :label="$t('warehouse.one-item')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.one-item'
              )}`"
              v-model="itemId"
              param-query="search"
              :other-query="`filter[type]=${
                this.$route.name.includes('pharmacy') ? 'pharmacy' : 'hospital'
              }`"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
            />
          </b-col>
          <b-col md="4" cols="12">
            <AutoComplete
              :label="$t('warehouse.one-warehouse')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.one-warehouse'
              )}`"
              v-model="warehouseId"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="warehouse"
              :other-query="`filter[type]=${
                this.$route.name.includes('pharmacy') ? 'pharmacy' : 'hospital'
              }`"
              text-title="name"
            />
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('warehouse.exp-date')" label-for="Name">
              <datepicker
                v-model="dateFilter"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                :disabled-dates="{
                  to: new Date(new Date().setDate(new Date().getDate() - 1)),
                }"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getBalanceList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("warehouse.balance") }}</h2>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(expiry_date)="data">
            <b-badge :variant="getExpiryBadgeVariant(data.item.expiry_date)">
              <feather-icon icon="ClockIcon" size="15" />
              {{ data.item.expiry_date }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <b-button pill variant="primary" @click="show(data.item)">
              {{ $t("warehouse.Dispensewarehouse") }}</b-button
            >
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("warehouse.one-item") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getBalanceList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BBadge,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
const CategoryFilterModal = () =>
  import("@/components/warehouse/CategoryFilterModal.vue");

export default {
  components: {
    BCard,
    BBadge,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    StatisticCardHorizontal,
    AutoComplete,
    CategoryFilterModal,
    Datepicker,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        balance_id: "",
        quantity: "",
        price: "",
      },
      createMode: false,
      errorForm: {
        name: "",
        category_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "item.name", label: this.$t("common.name"), sortable: true },
        {
          key: "category.name",
          label: this.$t("warehouse.one-category"),
          sortable: true,
        },
        {
          key: "warehouse.name",
          label: this.$t("warehouse.one-warehouse"),
          sortable: true,
        },
        {
          key: "batch_no",
          label: this.$t("warehouse.batch-no"),
          sortable: true,
        },
        {
          key: "expiry_date",
          label: this.$t("warehouse.exp-date"),
          sortable: true,
        },
        {
          key: "quantity",
          label: this.$t("warehouse.quantity"),
          sortable: true,
        },
        {
          key: "purchase_price",
          label: this.$t("warehouse.purchase-price"),
          sortable: true,
        },
        {
          key: "sell_price",
          label: this.$t("warehouse.sell-price"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("common.actions"),
          sortable: true,
        },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      dispenceItem: {},
      date: this.formatExpDate(Date.now()),
      quantity: 0,
      price: 0,
      dateFilter: null,
      itemId: null,
      categoryId: null,
      warehouseId: null,
    };
  },
  mounted() {
    this.getBalanceList();
  },
  methods: {
    show(item) {
      console.log(item, "ssss");
      this.EditForm.balance_id = item.id;
      this.EditForm.quantity = 0;
      this.EditForm.price = item.sell_price;
      this.$bvModal.show("modal-edit");
    },
    getExpiryBadgeVariant(expiryDate) {
      const today = new Date();
      const expirationDate = new Date(expiryDate);
      const timeDifference = expirationDate - today;

      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

      if (daysDifference > 60) {
        return "success"; // More than 2 months
      } else if (daysDifference > 0 && daysDifference <= 60) {
        return "warning"; // Between today and 2 months
      } else {
        return "danger"; // Today or in the past
      }
    },
    assignCategoryFilter(v) {
      this.categoryId = v.id;
    },

    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    formatExpDate(expDate) {
      // Create a new Date object from the selected date
      const date = new Date(expDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1); // getMonth() is zero-based
      let day = "" + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },
    async getBalanceList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/balance?filter[type]=${
        this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital"
      }&page=${this.page}&take=${
        this.take
      }&sort=-created_at&include=category,item,warehouse`;

      if (this.itemId) {
        url += `&filter[item_id]=${this.itemId}`;
      }
      if (this.categoryId) {
        url += `&filter[category_id]=${this.categoryId}`;
      }
      if (this.dateFilter) {
        url += `&filter[expiry_date]=${this.formatExpDate(this.dateFilter)}`;
      }
      if (this.warehouseId) {
        url += `&filter[warehouse_id]=${this.warehouseId}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/balance/${this.deleteForm.id}`)
        .then((response) => {
          this.getBalanceList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      const data = {
        date: this.date,
        stockouts: [this.EditForm],
      };
      (this.params.form = data),
        (this.params.path = `/stockout`),
        this.$store
          .dispatch("create", this.params)
          .then((response) => {
            this.getBalanceList();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
